"use client";

import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/utils/supabase/client';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { MessageCircle } from 'lucide-react';

interface Comment {
  id: string;
  content: string;
  created_at: string;
  user_id: string;
  profiles: { first_name: string; last_name: string };
}

interface TaskCommentsListProps {
  taskId: string;
}

export const TaskCommentsList: React.FC<TaskCommentsListProps> = ({ taskId }: TaskCommentsListProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Comments (Coming Soon)</CardTitle>
      </CardHeader>
      <CardContent>
        <p>This feature is under development. Stay tuned!</p>
      </CardContent>
    </Card>
  );
};

export default TaskCommentsList;